module.exports = __webpack_public_path__ + "img/572.f41307f7.jpg";